import React from 'react';
import { GetServerSideProps } from 'next';
import { WipPage } from '@components/Pages/Wip';
import { getLocaleProps, LocaleProps, WithLocale } from '@components/I18n';
import { WithAuthentication, getAuthenticationProps, AuthenticationProps, PageWrapper } from '@components/.';

export const getServerSideProps: GetServerSideProps = async (context) => {
  const lang: string = context.params.lang as string;
  const localeProps = await getLocaleProps(lang);
  const authenticationProps = await getAuthenticationProps(context);

  return {
    props: {
      ...authenticationProps,
      ...localeProps
    }
  }
}

const Page: React.FC<LocaleProps & AuthenticationProps> = () => {
  return (
    <PageWrapper>
      <WipPage />
    </PageWrapper>
  );
}

const CompletePage: React.FC<LocaleProps & AuthenticationProps> = props => {
  return (
    <WithLocale {...props}>
      <WithAuthentication {...props}>
        <Page {...props} />
      </WithAuthentication>
    </WithLocale>
  );
}

export default CompletePage;



